import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';

import {IonicModule} from '@ionic/angular';

import {InsuranceDashboardPage} from './dashboard/insurance-dashboard.page';
import {UiCHeaderModule} from '@wlp/ui-c-header';
import {UiBsTranslateModule} from '@wlp/ui-bs-translate';
import {environment} from '../../../../../../../environments/environment';
import {InterceptService} from '../../../../../../core/intercept/intercept.service';
import {HTTP_INTERCEPTORS} from '@angular/common/http';
import {InsuranceRoutingModule} from './insurance-routing.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    InsuranceRoutingModule,
    UiCHeaderModule,
    UiBsTranslateModule.forRoot({ device: 'WEB', config: environment })
  ],
  declarations: [InsuranceDashboardPage],
  providers: [
    InterceptService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: InterceptService,
      multi: true,
    },
  ]
})
export class InsuranceModule {}
